<template>
  <div class="randomizer-tasklist-login">
    <p class="randomizer-tasklist-login_message white-text-20">
      {{
        $c('Чтобы увидеть ваши задания вам необходимо авторизоваться или завести игровой аккаунт, если у вас его еще нет')
      }}
    </p>
    <a :href="redirectUrl" class="button contained">Авторизоваться</a>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { getAuthenticationActionUrl } from '@/helpers'

@Component({
  components: {}
})
class LoginSection extends Vue {
  redirectUrl = getAuthenticationActionUrl('signin')
}

export default LoginSection
</script>

<style lang="scss" scoped>
  .randomizer-tasklist-login {
    display: block;
    &_message {
      margin-bottom: 47px;
    }
  }
</style>
